/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { JobPositionBusinessUnitPartial } from './jobPositionBusinessUnitPartial';
import { WorkExperiencePositionPartial } from './workExperiencePositionPartial';
import { JobPositionPartial } from './jobPositionPartial';
import { JobPositionCompetencePartial } from './jobPositionCompetencePartial';


export interface JobPositionControllerUpdateByIdRequest { 
    jobPosition?: JobPositionPartial;
    workExperiencePositions?: Array<WorkExperiencePositionPartial>;
    jobPositionCompetences?: Array<JobPositionCompetencePartial>;
    jobPositionBusinessUnits?: Array<JobPositionBusinessUnitPartial>;
}

